import Axios from "axios"

import { call, put, takeLatest } from "redux-saga/effects"
import { recoverSuccess, recoverFailed } from "./actions"
import { RECOVER_WATCHER } from "./constants"

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function recoverPasswordApi(email) {
  return Axios.request({
    method: "post",
    url: `${process.env.API_URL}password/reset/sendlink`,
    data: email,
  })
}

export function* recoverPasswordSaga(action) {
  try {
    const data = yield call(recoverPasswordApi, action.payload)
    yield put(recoverSuccess(data))
  } catch (e) {
    const response = e.response.data.data.error // AQUI PENDIENTE
    const key = Object.keys(response)[0]
    const res = response[key]
    messageFailed(res)
    yield put(recoverFailed())
  }
}

export default function* recoverWatcherSaga() {
  yield takeLatest(RECOVER_WATCHER, recoverPasswordSaga)
}
